import React from 'react';
import FormContainerWrapper from './FormContainerWrapper';
import Clock from '../../components/clock';
import Prizes from '../../components/prizes';
import Partners from '../../components/partners';
import Challenges from '../../components/challenges';
import Description from '../../components/description';
import FormButton from '../../components/formButton';
import TasksButton from '../../components/tasksButton';
import Questions from '../../components/questions';
import BackButton from '../../components/backButton';
import AgreeBox from '../../components/agreeBox';

const FormItems = props => {
    if (props.activeIndex === 0)
    {
        return <span>
            <Clock lang={props.lang} days={props.days} hours={props.hours} minutes={props.minutes} seconds={props.seconds} />
            <Prizes lang={props.lang} />
            <Partners lang={props.lang} selectedLanguage={props.selectedLanguage} />
        </span>
    }
    if (props.activeIndex === 1)
    {
        return <span>
            {/* <Description header={props.lang.form_container.about_heading} paragraph={props.lang.form_container.about_paragraph}/> */}
            {/* <TasksButton handleButtonClick={props.handleButtonClick} lang={props.lang} /> */}
            <Prizes lang={props.lang} selectedLanguage={props.selectedLanguage} />
            <Partners lang={props.lang} selectedLanguage={props.selectedLanguage} />
        </span>
    } 
    if (props.activeIndex === 2) {
        return <span>
        <BackButton lang={props.lang} handleButtonClick={props.handleButtonClick}/>
        <Challenges lang={props.lang} handleChallengeClick={props.handleChallengeClick}/>
        <Description task_info_header={props.lang.form_container.task_info_header} task_info_paragraph={props.lang.form_container.task_info_paragraph} header={props.lang.form_container[`${props.selectedChallenge}_subheader_1`]} challengeImage={props.lang.form_container[`${props.selectedChallenge}_image`]} videoUrl={props.lang.form_container[`${props.selectedChallenge}_video`]} watchVideoLabel={props.lang.watch_video_label} description_header={props.lang.form_container[`${props.selectedChallenge}_description_header`]} description_paragraph={props.lang.form_container[`${props.selectedChallenge}_description_paragraph`]} task_header={props.lang.form_container[`${props.selectedChallenge}_task_header`]} task_paragraph={props.lang.form_container[`${props.selectedChallenge}_task_paragraph`]} requirements_header={props.lang.form_container[`${props.selectedChallenge}_requirements_header`]} requirements_paragraph={props.lang.form_container[`${props.selectedChallenge}_requirements_paragraph`]}/>
        <Questions lang={props.lang}/>
        <AgreeBox lang={props.lang} isChecked={props.isChecked} handleCheck={props.handleCheck} selectedLanguage={props.selectedLanguage} />
        <FormButton lang={props.lang} selectedChallenge={props.selectedChallenge} isChecked={props.isChecked}/>
    </span>
    }
}


export default (props) => {
    return <FormContainerWrapper visible={props.visible}>
        <FormItems {...props} />
    </FormContainerWrapper>
}


// WEBPACK FOOTER //
// ./src/containers/FormContainer/index.jsx